import { render, staticRenderFns } from "./SettingsBots.vue?vue&type=template&id=2ddaf42b&scoped=true&"
import script from "./SettingsBots.vue?vue&type=script&lang=js&"
export * from "./SettingsBots.vue?vue&type=script&lang=js&"
import style0 from "./SettingsBots.vue?vue&type=style&index=0&id=2ddaf42b&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ddaf42b",
  null
  
)

export default component.exports